import {
    AdjustmentOperation,
    AdjustmentType,
    CatalogItem,
    DemographicPrice,
    EquipmentCatalogItem,
    Experience,
    LineItemTemplate,
    PricingTerm,
    UnitType,
} from "types";
import { generateBuyoutPricingCatalogItemPrices } from "./BuyoutPricingGroup";
import { getCatalogItemsByUnitType } from "./Catalog";
import { generateRelativePricingCatalogItemPrices } from "./RelativePricingGroup";

export const getEquipmentPricesForExperienceCatalog = (
    experience: Experience,
    pricingTerm: PricingTerm,
): DemographicPrice[] => {
    const catalogItems = getCatalogItemsByUnitType<EquipmentCatalogItem>(
        experience.catalog?.items ?? [],
        UnitType.EQUIPMENT,
    ).filter((catalogItem) => Boolean(catalogItem.template?.id));

    return catalogItems.map((catalogItem) => {
        const existing = pricingTerm?.demographicPrices?.find(
            (item) => item.template?.id !== undefined && item.template.id === catalogItem.template?.id,
        );
        return existing ? { ...existing, catalogItem } : { catalogItem, template: catalogItem.template! };
    });
};

export const generateRelativePricingEquipmentPrices = (
    catalogItems: CatalogItem[],
    adjustmentAmount = undefined,
    adjustmentOperation: AdjustmentOperation = AdjustmentOperation.MARKUP,
    adjustmentType: AdjustmentType = AdjustmentType.ABSOLUTE,
): DemographicPrice[] => {
    return generateRelativePricingCatalogItemPrices(
        catalogItems,
        UnitType.EQUIPMENT,
        adjustmentAmount,
        adjustmentOperation,
        adjustmentType,
    );
};

export const generateBuyoutPricingEquipmentPrices = (
    catalogItems: CatalogItem[],
    lineItemTemplates: LineItemTemplate[],
    adjustmentAmount = 0,
    adjustmentOperation: AdjustmentOperation = AdjustmentOperation.MARKDOWN,
    adjustmentType: AdjustmentType = AdjustmentType.ABSOLUTE,
): DemographicPrice[] => {
    return generateBuyoutPricingCatalogItemPrices(
        catalogItems,
        lineItemTemplates,
        UnitType.EQUIPMENT,
        adjustmentAmount,
        adjustmentOperation,
        adjustmentType,
    );
};
